import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UsersState } from './users.reducer';

export const selectUsersDataState = createFeatureSelector<UsersState>('users');

export const selectUsersList = createSelector(
  selectUsersDataState,
  (state: UsersState) => state.list
);

export const selectUsersPagination = createSelector(
  selectUsersDataState,
  (state: UsersState) => ({
      pageNumber: state.pageNumber,
      pageSize: state.pageSize,
      totalPages: state.totalPages,
      totalRecords: state.totalRecords
  })
);

export const selectUsersDataLoading = createSelector(
    selectUsersDataState,
    (state: UsersState) => state.loading
);

export const selectUsersDataError = createSelector(
    selectUsersDataState,
    (state: UsersState) => state.error
);
